import { BookingId } from "../../../../../../types/primitiveTypes"
import { transport } from "../../../../../../services/api/transport"
import mapperEmergencyBanners from "./mapperEmergencyBanners"
import { GET_EMERGENCY_BANNERS } from "./consts"

export const fetchEmergencyBannersAction = (bid: BookingId, phraseAppLang: string) => {
  const promise = transport("GET", bid, `/mmb/v1/bookings/${bid}/emergency_banners`, {
    language: phraseAppLang,
    platform: "web",
  }).then(mapperEmergencyBanners)

  return {
    type: GET_EMERGENCY_BANNERS.GET_EMERGENCY_BANNERS,
    promise,
  }
}
